const apiPrefix = process.env.NEXT_PUBLIC_APP_NAME;

function getNextApiRoute(pathname: string) {
    return apiPrefix ? `/api/${apiPrefix}/${pathname}` : `/api/${pathname}`;
}

export { getNextApiRoute };
